// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__iSSv8","faq":"FAQ_faq__29Ux-","homeContainer":"FAQ_homeContainer__ts8qu"};